import { ChequeListFilterColumn } from '../types';

export const chequeListFilter: ChequeListFilterColumn[] = [
  {
    name: 'Cheque No',
    value: 'cheque_no',
    isVisible: true
  },
  {
    name: 'DR No',
    value: 'dr_no',
    isVisible: true
  },
  {
    name: 'P.O. No',
    value: 'po_nos',
    isVisible: true
  },
  {
    name: 'Supplier',
    value: 'supplier',
    isVisible: true
  },
  {
    name: 'Terms',
    value: 'terms',
    isVisible: true
  },
  {
    name: 'PDC Date',
    value: 'pdc_date',
    isVisible: true
  },
  {
    name: 'Date Encoded',
    value: 'created_date',
    isVisible: true
  },
  {
    name: 'Amount',
    value: 'amount',
    isVisible: true
  },
  {
    name: 'Visible in Liability',
    value: 'liability',
    isVisible: true
  }
];
